import {CommentIcon} from '@primer/octicons-react'
import {useSuspenseActivityPageData} from '../../data/use-activity-page-data'
import {SidebarActivityRow} from './SidebarActivityRow'
import {hasIssueComments, pluralize} from './activity-row-helpers'

export function IssueCommentsRow() {
  const {summary} = useSuspenseActivityPageData()
  if (!hasIssueComments(summary)) return null

  const n = summary?.issueComments?.count ?? 0
  const label = `${n} ${pluralize(n, 'comment', 'comments')}`

  return <SidebarActivityRow icon={CommentIcon} label={label} group="issueComments" expectedCount={n} />
}
